import * as React from "react"
import { cn } from "@/lib/utils"

export interface InstagramIconProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Size of the icon in pixels
   * @default 18
   */
  size?: number
}

/**
 * Instagram icon as SVG
 *
 * This icon represents the Instagram social network platform.
 *
 * @example
 * ```tsx
 * <InstagramIcon />
 * <InstagramIcon size={24} className="text-pink-600" />
 * ```
 */
export const InstagramIcon = React.forwardRef<SVGSVGElement, InstagramIconProps>(
  ({ size = 18, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        className={cn("inline-flex shrink-0", className)}
        aria-hidden="true"
        {...props}
      >
        <path d="M9.00195 4.38867C6.44531 4.38867 4.39258 6.44141 4.39258 8.99805C4.39258 11.5547 6.44531 13.6074 9.00195 13.6074C11.5586 13.6074 13.6113 11.5547 13.6113 8.99805C13.6113 6.44141 11.5586 4.38867 9.00195 4.38867ZM9.00195 12.0039C7.34766 12.0039 5.99609 10.6562 5.99609 8.99805C5.99609 7.33984 7.34375 5.99219 9.00195 5.99219C10.6602 5.99219 12.0078 7.33984 12.0078 8.99805C12.0078 10.6562 10.6562 12.0039 9.00195 12.0039ZM14.8828 4.20703C14.8828 4.79688 14.4062 5.26953 13.8203 5.26953C13.2305 5.26953 12.7578 4.79297 12.7578 4.20703C12.7578 3.62109 13.2344 3.14453 13.8203 3.14453C14.4062 3.14453 14.8828 3.62109 14.8828 4.20703ZM17.9336 5.28516C17.8672 3.87109 17.5391 2.62109 16.5117 1.59766C15.4883 0.574219 14.2383 0.246094 12.8242 0.175781C11.3672 0.0898438 6.63281 0.0898438 5.17578 0.175781C3.76562 0.242188 2.51562 0.570312 1.48828 1.59375C0.460938 2.61719 0.136719 3.86719 0.0664062 5.28125C-0.0195312 6.73828 -0.0195312 11.4727 0.0664062 12.9297C0.132812 14.3438 0.460938 15.5938 1.48828 16.6172C2.51562 17.6406 3.76172 17.9688 5.17578 18.0391C6.63281 18.125 11.3672 18.125 12.8242 18.0391C14.2383 17.9727 15.4883 17.6445 16.5117 16.6172C17.5352 15.5938 17.8633 14.3438 17.9336 12.9297C18.0195 11.4727 18.0195 6.74219 17.9336 5.28516ZM16.0039 14.4961C15.6914 15.3203 15.0547 15.957 14.2266 16.2734C13.0664 16.6211 10.2578 16.5117 9.00195 16.5117C7.74609 16.5117 4.93359 16.6172 3.77734 16.2734C2.95312 15.9609 2.31641 15.3242 2 14.4961C1.65234 13.3359 1.76172 10.5273 1.76172 9.27148C1.76172 8.01562 1.65625 5.20312 2 4.04688C2.3125 3.22266 2.94922 2.58594 3.77734 2.26953C4.9375 1.92188 7.74609 2.03125 9.00195 2.03125C10.2578 2.03125 13.0703 1.92578 14.2266 2.26953C15.0508 2.58203 15.6875 3.21875 16.0039 4.04688C16.3516 5.20703 16.2422 8.01562 16.2422 9.27148C16.2422 10.5273 16.3516 13.3398 16.0039 14.4961Z" />
      </svg>
    )
  }
)

InstagramIcon.displayName = "InstagramIcon"
